import type { Reducer } from 'redux';

import type { SessionConfigureAction } from '../../../domains/sessionConfigure/actions.types';

import type { OcvConfig } from './types';

export type OcvAction = SessionConfigureAction;

const initialState: OcvConfig = {
  yammerAppId: 0,
};

const reducer: Reducer<OcvConfig, OcvAction> = (state = initialState, action) => {
  switch (action.type) {
    case 'SESSION.CONFIGURE':
      return action.payload.ocv;
    default:
      return state;
  }
};

export default reducer;
